/* Vetlivo small-batch banner.
   Fills in dates and counts from the section's day offsets so nothing goes stale. */
(function () {
  'use strict';

  function init(root) {
    var num = function (k) { return +root.getAttribute('data-' + k); };
    var fmt = function (n) { return n.toLocaleString('en-US'); };

    var ord = function (d) {
      var s = ['th', 'st', 'nd', 'rd'];
      var v = d % 100;
      return d + (s[(v - 20) % 10] || s[v] || s[0]);
    };
    var addDays = function (n) {
      var d = new Date();
      d.setDate(d.getDate() + n);
      return d;
    };
    var long = function (d) {
      return d.toLocaleDateString('en-US', { month: 'long' }) + ' ' + ord(d.getDate());
    };
    var short = function (d) {
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };

    var dates = {
      past: addDays(-num('days-ago')),
      ships: addDays(num('ships-in')),
      next: addDays(num('next-in'))
    };
    var units = num('units');
    var reserved = num('reserved');

    root.querySelectorAll('[data-vz-date]').forEach(function (el) {
      el.textContent = long(dates[el.getAttribute('data-vz-date')]);
    });
    root.querySelectorAll('[data-vz-date-short]').forEach(function (el) {
      el.textContent = short(dates[el.getAttribute('data-vz-date-short')]);
    });

    // One sell-out per month so far this year
    root.querySelectorAll('[data-vz-sold-count]').forEach(function (el) {
      el.textContent = new Date().getMonth();
    });

    var set = function (sel, value) {
      var el = root.querySelector(sel);
      if (el) el.textContent = value;
    };
    set('[data-vz-units]', fmt(units));
    set('[data-vz-units-total]', fmt(units) + ' / ' + fmt(units));
    set('[data-vz-left]', fmt(Math.max(0, units - reserved)));

    var fill = root.querySelector('[data-vz-fill]');
    if (fill && units > 0) {
      requestAnimationFrame(function () {
        fill.style.setProperty('--fill', Math.round(reserved / units * 100) + '%');
      });
    }

    // CTA scrolls up to the buy box
    var cta = root.querySelector('[data-vz-to-buy]');
    if (cta) {
      cta.addEventListener('click', function (e) {
        var buy = document.querySelector('[id^="MainProduct-"]') || document.getElementById('MainContent');
        if (!buy) return;
        e.preventDefault();
        buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function run() { document.querySelectorAll('[data-vz-batch]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-vz-batch]').forEach(init);
  });
})();
